import { Operator } from 'dashboard/models/graph-query';
import { assertNever } from 'lib/utils/types';

/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
export const operatorDisplayValue = (operator: Operator, _criterion: string = null): string => {
  switch (operator) {
    case Operator.Equals:
      return 'equals';
    case Operator.Matches:
      return 'matches';
    case Operator.Includes:
      return 'includes';
    case Operator.IncludesAllOf:
      return 'all of';
    case Operator.IncludesAnyOf:
      return 'any of';
    case Operator.Before:
      return 'is before';
    case Operator.After:
      return 'is after';
    case Operator.Between:
      return 'is between';
    case Operator.LessThan:
      return 'less than';
    case Operator.GreaterThan:
      return 'greater than';
    case Operator.PartiallyMatches:
      return 'partially matches';
    case Operator.IsNotNull:
      return 'is not null';
    case Operator.IsNull:
      return 'is null';
    case Operator.IsAnyOf:
      return 'is any of';
    case Operator.Within:
      return 'within';
    default:
      assertNever(operator);
  }
};
